// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ball-scale-ripple-multiple {
  0% {
    transform: scale(0.1);
    opacity: 1;
  }
  70% {
    transform: scale(1);
    opacity: 0.7;
  }
  100% {
    opacity: 0;
  }
}
.ball-scale-ripple-multiple {
  position: relative;
  transform: translateY(-25px);
}
.ball-scale-ripple-multiple > div:nth-child(0) {
  animation-delay: -0.8s;
}
.ball-scale-ripple-multiple > div:nth-child(1) {
  animation-delay: -0.6s;
}
.ball-scale-ripple-multiple > div:nth-child(2) {
  animation-delay: -0.4s;
}
.ball-scale-ripple-multiple > div:nth-child(3) {
  animation-delay: -0.2s;
}
.ball-scale-ripple-multiple > div {
  animation-fill-mode: both;
  position: absolute;
  top: -2px;
  left: -26px;
  width: 50px;
  height: 50px;
  border-radius: 100%;
  border: 2px solid #fff;
  animation: ball-scale-ripple-multiple 1.25s 0s infinite cubic-bezier(0.21, 0.53, 0.56, 0.8);
}

.loader-container {
  align-items: center;
  display: flex;
  height: calc(100% - 50px);
  justify-content: center;
  width: 100%;
  text-align: center;
  line-height: 1.6rem;
}

.loader-container .loader-container-inner {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./node_modules/loaders.css/src/animations/ball-scale-ripple-multiple.scss","webpack://./src/components/ChartLoader/index.scss","webpack://./node_modules/loaders.css/src/_mixins.scss"],"names":[],"mappings":"AAMA;EACE;IACE,qBAAA;IACA,UAAA;ECLF;EDOA;IACE,mBAAA;IACA,YAAA;ECLF;EDOA;IACE,UAAA;ECLF;AACF;ADgBA;EAGE,kBAAA;EACA,4BAAA;AChBF;ADMI;EACE,sBAAA;ACJN;ADGI;EACE,sBAAA;ACDN;ADAI;EACE,sBAAA;ACEN;ADHI;EACE,sBAAA;ACKN;ADME;EE7BA,yBAAA;EFgCE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WApCG;EAqCH,YArCG;EAsCH,mBAAA;EACA,sBAAA;EACA,2FAAA;ACLJ;;AArCA;EACE,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AAwCF;;AArCA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,UAAA;AAwCF","sourcesContent":["@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n$size: 50px;\n\n@keyframes ball-scale-ripple-multiple {\n  0% {\n    transform: scale(0.1);\n    opacity: 1;\n  }\n  70% {\n    transform: scale(1);\n    opacity: 0.7;\n  }\n  100% {\n    opacity: 0.0;\n  }\n}\n\n@mixin ball-scale-ripple-multiple ($n:3, $start:0) {\n  @for $i from $start through $n {\n    > div:nth-child(#{$i}) {\n      animation-delay: delay(0.2s, $n, $i - 1);\n    }\n  }\n}\n\n.ball-scale-ripple-multiple {\n  @include ball-scale-ripple-multiple();\n\n  position: relative;\n  transform: translateY(-$size / 2);\n\n  > div {\n    @include global-animation();\n\n    position: absolute;\n    top: -2px;\n    left: -26px;\n    width: $size;\n    height: $size;\n    border-radius: 100%;\n    border: 2px solid $primary-color;\n    animation: ball-scale-ripple-multiple 1.25s 0s infinite cubic-bezier(.21,.53,.56,.8);\n  }\n}\n","@import 'loaders.css/src/animations/ball-scale-ripple-multiple.scss';\r\n\r\n.loader-container {\r\n  align-items: center;\r\n  display: flex;\r\n  height: calc(100% - 50px);\r\n  justify-content: center;\r\n  width: 100%;\r\n  text-align: center;\r\n  line-height: 1.6rem;\r\n}\r\n\r\n.loader-container .loader-container-inner {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-direction: column;\r\n  padding: 0;\r\n}","@mixin global-bg() {\n  background-color: $primary-color;\n}\n\n@mixin global-animation() {\n  animation-fill-mode: both;\n}\n\n@mixin balls() {\n  @include global-bg();\n\n  width: $ball-size;\n  height: $ball-size;\n  border-radius: 100%;\n  margin: $margin;\n}\n\n@mixin lines() {\n  @include global-bg();\n\n  width: $line-width;\n  height: $line-height;\n  border-radius: 2px;\n  margin: $margin;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
